
export class PopTituloUpdate {
  public id: number;
  public texto: string;

  constructor( id: number, texto: string) {
    this.id = id;
    this.texto = texto;
  }
}